export function setCookie(cname, cvalue, exhours, domain = '') {
	const d = new Date();
	d.setTime(d.getTime() + (exhours * 60 * 60 * 1000));
	const expires = 'expires=' + d.toUTCString();
	const dom = domain ? `; Domain=${domain}` : '';
	document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/' + dom;
}

export function getCookie(name) {
	// eslint-disable-next-line
  const matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
	return matches ? decodeURIComponent(matches[1]) : undefined;
}



// WEBPACK FOOTER //
// ./frontend/shared/js/cookie.js